import { TOGGLE_BURGER_STATE } from "../types";

export function toggleBurgerStatement() {
  return {
    type: TOGGLE_BURGER_STATE,
  };
}
